var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EventForm',{attrs:{"event":_vm.event,"is-loading":_vm.isLoading},on:{"save":_vm.onSaveClick,"cancel":_vm.onCancelClick,"cancelEvent":_vm.onCancelEventClick,"detachEvent":_vm.onDetachEventClick}})}
var staticRenderFns = []

export { render, staticRenderFns }